import { FC } from "react";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";
import cx from "apps/website/utils/misc/cx";

interface IClipPath {
  topLeft: string;
  topRight: string;
  bottomRight: string;
  bottomLeft: string;
}

export interface IPolygon {
  className?: string;
  bgColor?: Theme;
  clipPath?: IClipPath;
}

export const Polygon: FC<IPolygon> = ({ className, bgColor = "sand-200", clipPath }) => {
  const { topLeft = "0% 0%",
    topRight = "100% 0%",
    bottomRight = "100% 100%",
    bottomLeft = "0% 100%" } = clipPath || {};

  const computedClassName = cx(
    themeRootClassMap[bgColor],
    className,

  );

  return (
    <div data-component={Polygon.name}
      className={computedClassName}
      style={
        { clipPath: `polygon(${topLeft}, ${topRight}, ${bottomRight}, ${bottomLeft})` }
      }
    />
  );
};
